import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'
import { format } from 'date-fns'

const initialState = {
  environmentData: {
    status: "idle",
    data: {},
    error: {},
  },
}

export const fetchEnvironment = createAsyncThunk('environment', async (data) => {
  const {token, section, period, selection, selectedFromDate, selectedToDate} = data
  const axios = require("axios")
  const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
  let url = `/api/v0/data/environment/YILI/${section}/${selection}/${period}`
  if (period === "custom") {
    const fromURI = encodeURIComponent(format(selectedFromDate, "yyyy-MM-dd"))
    const toURI = encodeURIComponent(format(selectedToDate, "yyyy-MM-dd"))
    url = `/api/v0/data/environment/YILI/${section}/${selection}/${period}?from=${fromURI}&to=${toURI}`
  } else {
    url = `/api/v0/data/environment/YILI/${section}/${selection}/${period}`
  }
  const response = await axios.get(url , { headers })
  return response.data
})

const environmentSlice = createSlice({
  name: 'environment',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchEnvironment.pending.type]:(state, action) => {
      state.environmentData = {
        status: "loading",
        data: {},
        error: {},
      }
    },
    [fetchEnvironment.fulfilled.type]:(state, action) => {
      state.environmentData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchEnvironment.rejected.type]:(state, action) => {
      state.environmentData = {
        status: "idle",
        data: {},
        error: "unauthorized",
      }
    },
  }
})

export default environmentSlice.reducer
